import { Lazy } from '@netc/lazy';
import whenDomReady from 'when-dom-ready';

export default function initialiseLazyImages() {
  const lazy = new Lazy();

  const imageElements = document.querySelectorAll('.js-lazy');
  const backgroundImageElements = document.querySelectorAll('.js-lazy-bg');

  if (backgroundImageElements.length > 0) {
    Array.forEach(backgroundImageElements, element => {
      lazy.registerBackgroundImageElement(element);
    });
  }

  if (imageElements.length > 0) {
    Array.forEach(imageElements, element => {
      lazy.registerImageElement(element);
    });
  }
}

whenDomReady().then(initialiseLazyImages);
